module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-tab2-5",
      "name": "hres32e-tab2-tab5"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['20']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codtitle[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codtitle),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codtitle", $$v)
      },
      expression: "detail.codtitle"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['41']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namfirst),
      expression: "detail.namfirst"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "namfirst",
      "name": "namfirst",
      "maxlength": "30",
      "data-vv-name": "namfirst",
      "has-error": _vm.errors.has('namfirst')
    },
    domProps: {
      "value": (_vm.detail.namfirst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namfirst", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namfirst')),
      expression: "errors.has('namfirst')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('namfirst')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['42']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namlast),
      expression: "detail.namlast"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "namlast",
      "name": "namlast",
      "maxlength": "30",
      "data-vv-name": "namlast",
      "has-error": _vm.errors.has('namlast')
    },
    domProps: {
      "value": (_vm.detail.namlast)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namlast", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namlast')),
      expression: "errors.has('namlast')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('namlast')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numspid),
      expression: "detail.numspid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:13'),
      expression: "'max:13'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numspid",
      "name": "numspid",
      "maxlength": "13",
      "data-vv-name": "numspid",
      "has-error": _vm.errors.has('numspid')
    },
    domProps: {
      "value": (_vm.detail.numspid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numspid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numspid')),
      expression: "errors.has('numspid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numspid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtespbd",
      "has-error": _vm.errors.has('dtespbd')
    },
    model: {
      value: (_vm.detail.dtespbd),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtespbd", $$v)
      },
      expression: "detail.dtespbd"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtespbd')),
      expression: "errors.has('dtespbd')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtespbd')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codfoccu[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codspocc),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codspocc", $$v)
      },
      expression: "detail.codspocc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desnoffi),
      expression: "detail.desnoffi"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "id": "desnoffi",
      "name": "desnoffi",
      "maxlength": "50",
      "data-vv-name": "desnoffi",
      "has-error": _vm.errors.has('desnoffi')
    },
    domProps: {
      "value": (_vm.detail.desnoffi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desnoffi", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desnoffi')),
      expression: "errors.has('desnoffi')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desnoffi')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(50)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 pull-left"
  }, [_c('div', {
    staticClass: "col-xs-12  card-ui clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic2
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['30']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic2),
      expression: "subTopic2"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtemarry",
      "has-error": _vm.errors.has('dtemarry')
    },
    model: {
      value: (_vm.detail.dtemarry),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtemarry", $$v)
      },
      expression: "detail.dtemarry"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtemarry')),
      expression: "errors.has('dtemarry')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtemarry')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desplreg),
      expression: "detail.desplreg"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "desplreg",
      "name": "desplreg",
      "maxlength": "20",
      "data-vv-name": "desplreg",
      "has-error": _vm.errors.has('desplreg')
    },
    domProps: {
      "value": (_vm.detail.desplreg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desplreg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desplreg')),
      expression: "errors.has('desplreg')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desplreg')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codprovr[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codsppro),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codsppro", $$v)
      },
      expression: "detail.codsppro"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.dropdowns.codcount[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.codspcty),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codspcty", $$v)
      },
      expression: "detail.codspcty"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC7']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desnote),
      expression: "detail.desnote"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "id": "desnote",
      "name": "desnote",
      "maxlength": "50",
      "data-vv-name": "desnote",
      "has-error": _vm.errors.has('desnote')
    },
    domProps: {
      "value": (_vm.detail.desnote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desnote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desnote')),
      expression: "errors.has('desnote')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desnote')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(50)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d48582b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab2_5.vue
// module id = 3844
// module chunks = 1